import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import {
  TPostSshKeyRotationGenerateRequestSchema,
  TPostSshKeyRotationGenerateResponseSchema,
} from "./postSshKeyRotationGenerate.schema";

export const postSshKeyRotationGenerate = (axios: IAxiosInstance) => {
  return async (data: TPostSshKeyRotationGenerateRequestSchema) => {
    const response = await axios.noRetry.post<
      IApiResponse<TPostSshKeyRotationGenerateResponseSchema>
    >("/api/sshKeyRotations/generate", data);

    if (!response?.data?.success) {
      throw new Error("Something went wrong");
    }

    return response?.data?.data;
  };
};
